import { render, staticRenderFns } from "./RequisitionApprovalFlowTemplates.vue?vue&type=template&id=660b0ba5"
import script from "./RequisitionApprovalFlowTemplates.vue?vue&type=script&lang=js"
export * from "./RequisitionApprovalFlowTemplates.vue?vue&type=script&lang=js"
import style0 from "./RequisitionApprovalFlowTemplates.vue?vue&type=style&index=0&id=660b0ba5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports